import { initDB } from './dbService';

// Couleurs par défaut avec les nouvelles couleurs primary et secondary
const DEFAULT_COLORS = {
  confirmed: '#4caf50',
  optionPlus: '#ff9800',
  optionMoins: '#f44336',
  separatorPeriod: '#4a6fa5',
  pastEvents: '#E0EADF',
  primaryColor: '#4a6fa5',   // NOUVEAU
  secondaryColor: '#166088'  // NOUVEAU
};

/**
 * Charger les couleurs personnalisées
 */
export async function loadCustomColors() {
  try {
    const db = await initDB();

    if (!db.objectStoreNames.contains('customColors')) {
      console.log('Store customColors non trouvé, utilisation des couleurs par défaut');
      return DEFAULT_COLORS;
    }

    const transaction = db.transaction(['customColors'], 'readonly');
    const store = transaction.objectStore('customColors');

    const result = await new Promise((resolve, reject) => {
      const request = store.get('colors');
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });

    if (result) {
      // S'assurer que les nouvelles propriétés existent
      return {
        ...DEFAULT_COLORS,
        ...result.colors
      };
    }

    return DEFAULT_COLORS;
  } catch (error) {
    console.error('Erreur lors du chargement des couleurs:', error);
    return DEFAULT_COLORS;
  }
}

/**
 * Sauvegarder les couleurs personnalisées
 */
export async function saveCustomColors(colors) {
  try {
    const db = await initDB();

    if (!db.objectStoreNames.contains('customColors')) {
      throw new Error('Store customColors non disponible');
    }

    const transaction = db.transaction(['customColors'], 'readwrite');
    const store = transaction.objectStore('customColors');

    await new Promise((resolve, reject) => {
      const request = store.put({
        id: 'colors',
        colors: colors
      });
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });

    return true;
  } catch (error) {
    console.error('Erreur lors de la sauvegarde des couleurs:', error);
    throw error;
  }
}

/**
 * Appliquer les couleurs personnalisées au CSS
 */
export function applyCustomColors(colors) {
  // AJOUTER une vérification de sécurité
  if (!colors || typeof colors !== 'object') {
    console.warn('Aucune couleur fournie, utilisation des couleurs par défaut');
    colors = DEFAULT_COLORS;
  }

  const root = document.documentElement;

  root.style.setProperty('--confirmed-color', colors.confirmed || DEFAULT_COLORS.confirmed);
  root.style.setProperty('--option-plus-color', colors.optionPlus || DEFAULT_COLORS.optionPlus);
  root.style.setProperty('--option-moins-color', colors.optionMoins || DEFAULT_COLORS.optionMoins);
  root.style.setProperty('--separator-period-color', colors.separatorPeriod || DEFAULT_COLORS.separatorPeriod);
  root.style.setProperty('--past-background', colors.pastEvents || DEFAULT_COLORS.pastEvents);
  // NOUVEAUX
  root.style.setProperty('--primary-color', colors.primaryColor || DEFAULT_COLORS.primaryColor);
  root.style.setProperty('--secondary-color', colors.secondaryColor || DEFAULT_COLORS.secondaryColor);
}

// Exporter les couleurs par défaut
export { DEFAULT_COLORS };